module.exports = __webpack_public_path__ + "img/pic12.d6567c8.webp";